import React from 'react';

const Itemcategory = (props) => {

    return (
        <div
            className="item-category"
            onClick={props.setCategory} >
            <div className="pic">
                <img src={props.image} />
            </div>
            <span>{props.title}</span>
        </div>
    );
}

export default Itemcategory;